"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var listActions = require("@caddigital/sok-reducers/lib/actions/user/list");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var userProjectsActions = require("@caddigital/sok-reducers/lib/actions/user/projects");
var ListRow_1 = require("./ListRow");
var Types = require("types");
var translate_1 = require("utils/translate");
var SortButton = sok_ui_1.Table.SortButton;
var getHeaders = function () { return [
    {
        orderBy: 'name',
        label: (0, translation_1.getLocalization)('admin/userManagement/MetaDataHeaders/name')
    },
    {
        orderBy: 'email',
        label: (0, translation_1.getLocalization)('admin/userManagement/MetaDataHeaders/email')
    },
    {
        orderBy: 'company',
        label: (0, translation_1.getLocalization)('admin/userManagement/MetaDataHeaders/company')
    },
    {
        orderBy: 'level',
        label: (0, translation_1.getLocalization)('admin/userManagement/MetaDataHeaders/customerGroup')
    }
]; };
var mapStateToProps = function (state) {
    var headers = getHeaders();
    var orderBy = headers.find(function (_a) {
        var orderBy = _a.orderBy;
        return orderBy === state.user.list.orderBy;
    });
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        token: state.auth.current.token,
        list: state.user.list,
        order: state.user.list.order,
        orderBy: (orderBy || headers[0]).orderBy,
        orderByLabel: (orderBy || headers[0]).label,
        selectedLanguage: selectedLanguage,
        headers: headers
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (_a) {
        var list = _a.list;
        return function () {
            return dispatch(listActions.fetchUserListRequest(list.offset, list.limit, list.order, list.orderBy, list.searchString));
        };
    },
    setOrderBy: function (_a, orderBy) {
        var list = _a.list;
        return function () {
            var order = orderBy === list.orderBy && list.order === 'asc' ? 'desc' : 'asc';
            return (dispatch(listActions.setOrderBy(orderBy)),
                dispatch(listActions.setOrder(order)),
                dispatch(listActions.fetchUserListRequest(list.offset, list.limit, order, orderBy, list.searchString)));
        };
    },
    setOrder: function (_a, order) {
        var list = _a.list;
        return function () { return (dispatch(listActions.setOrder(order)),
            dispatch(listActions.fetchUserListRequest(list.offset, list.limit, order, list.orderBy, list.searchString))); };
    },
    onPaginationChange: function (_a) {
        var list = _a.list;
        return function (offset, limit) { return (dispatch(listActions.setLimit(limit)),
            dispatch(listActions.setOffset(offset)),
            dispatch(listActions.fetchUserListRequest(offset, limit, list.order, list.orderBy, list.searchString))); };
    },
    toggleOrderByDropdown: function () { return dispatch(listActions.toggleOrderByDropdown()); },
    editUser: function (user, action) {
        return dispatch(userSettingsActions.openUserSettingsModal(user, 'ADMIN', [action]));
    },
    toggleModal: function (user) {
        return dispatch(userProjectsActions.fetchProjectsRequests(user));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'user-management-view-list', key: 'list' },
        props.list.status === 'STANDBY' && (React.createElement("div", { className: 'user-management-view-list-standby' },
            React.createElement("img", { src: '/assets/sokopro_mario_icon.svg' }),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/system/userManagement/dearGranoAdmin')),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/system/userManagement/pleaseSearchUsersBy')))),
        props.list.status === 'FETCHED' && (React.createElement(sok_ui_1.Table.Table, { className: 'striped hovered' },
            React.createElement(sok_ui_1.Table.Head, null,
                React.createElement(sok_ui_1.Table.Row, null,
                    React.createElement(sok_ui_1.Table.Column, null),
                    props.headers.map(function (val, key) { return (React.createElement(sok_ui_1.Table.Column, { key: key },
                        React.createElement(SortButton, { order: val.orderBy === props.orderBy
                                ? props.order.toLowerCase()
                                : undefined, onChange: props.setOrderBy(props, val.orderBy) }, val.label))); }),
                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('admin/system/userManagement/projects')),
                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('admin/system/userManagement/edit')))),
            React.createElement(sok_ui_1.Table.Body, null, props.list.list.map(function (row) { return (React.createElement(ListRow_1.ListRow, { key: row.id, props: props, row: row })); })))),
        props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { title: 'Error fetching list' },
            React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.fetch(props) }))),
        props.list.status === 'FETCHING' && (React.createElement("div", { className: 'user-management-view-list-loading' },
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        props.list.status === 'FETCHED' && (React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.list.limit, total: props.list.total, offset: props.list.offset, updatePageState: props.onPaginationChange(props) }))))); });
